var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import MaterialRadio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
// styles
import "./radio.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-radio",
    size: "medium",
};
const CustomRadio = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (_jsx(MaterialRadio, Object.assign({ disableRipple: true, color: "default", checkedIcon: _jsx("div", { className: classNames("radioButton-container", "checked", size), children: _jsx("div", { className: "radioButton-element" }) }), icon: _jsx("div", { className: classNames("radioButton-container", size), children: _jsx("div", { className: "radioButton-element" }) }) }, props)));
};
const Radio = (_a) => {
    var { className, value, label } = _a, rest = __rest(_a, ["className", "value", "label"]);
    const classList = classNames("tecma-radio", className);
    return (_jsx(FormControlLabel, { className: classList, value: value, label: label, control: _jsx(CustomRadio, Object.assign({}, rest)) }));
};
Radio.defaultProps = defaultProps;
export default React.memo(Radio);
